import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./store/store";
import { AuthContextProvider } from "./authContext/AuthContext";
import "./fonts/Peyda.eot";
import "./fonts/Peyda.woff";
import "./fonts/Peyda.ttf";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AuthContextProvider>
          <App />
        </AuthContextProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
